import { Schema as S } from "effect";

const AddressSchema = S.Struct({
  houseno: S.optional(S.String),
  zip: S.optional(S.String),
  city: S.optional(S.String),
  postbox: S.optional(S.String),
  kind: S.optional(
    S.Union(
      [S.Literal("OFFICIAL"),
      S.Literal("POSTBOX"),
      S.Literal("POSTAL"),
      S.Literal("BILLING"),
      S.Literal("VISIT"),
      S.Literal("EMPLOYER")],
    ),
  ),
  country: S.optional(S.String),
  countryCode: S.optional(S.String),
  receiver: S.optional(S.String),
  payerType: S.optional(S.String),
  addon: S.optional(S.String),
  street: S.optional(S.String),
  firstname: S.optional(S.String),
  lastname: S.optional(S.String),
});

const CommunicationSchema = S.Struct({
  type: S.optional(
    S.Union(
      [S.Literal("PHONEPRIV"),
      S.Literal("FAXPRIV"),
      S.Literal("MOBILEPRIV"),
      S.Literal("PHONEJOB"),
      S.Literal("FAXJOB"),
      S.Literal("MOBILEJOB"),
      S.Literal("EMAILPRIV"),
      S.Literal("EMAILJOB"),
      S.Literal("KIM"),
      S.Literal("FACEBOOK"),
      S.Literal("GOOGLE"),
      S.Literal("OTHER"),
      S.Literal("LINKEDIN"),
      S.Literal("XING"),
      S.Literal("URL"),
      S.Literal("PHONEEXT"),
      S.Literal("PHONEEMERGENCY")],
    ),
  ),
  preferred: S.optional(S.Boolean),
  notAvailable: S.optional(S.Boolean),
  value: S.optional(S.String),
  note: S.optional(S.String),
  signaling: S.optional(S.Boolean),
  confirmed: S.optional(S.Boolean),
  confirmNeeded: S.optional(S.Boolean),
});

const InsuranceStatusSchema = S.Struct({
  insuranceNo: S.optional(S.String),
  kvkHistoricalNo: S.optional(S.String),
  insuranceId: S.optional(S.String),
  mainInsuranceId: S.optional(S.String),
  daleUvInsuranceId: S.optional(S.String),
  insuranceName: S.optional(S.String),
  daleUvInsuranceName: S.optional(S.String),
  insurancePrintName: S.optional(S.String),
  insuranceCountry: S.optional(S.String),
  insuranceGrpId: S.optional(S.String),
  paidFreeTo: S.optional(S.String),
  type: S.optional(
    S.Union(
      [S.Literal("PUBLIC"),
      S.Literal("PUBLIC_A"),
      S.Literal("PRIVATE"),
      S.Literal("PRIVATE_A"),
      S.Literal("PRIVATE_CH"),
      S.Literal("PRIVATE_CH_IVG"),
      S.Literal("PRIVATE_CH_MVG"),
      S.Literal("PRIVATE_CH_UVG"),
      S.Literal("PRIVATE_CH_VVG"),
      S.Literal("SELFPAYER"),
      S.Literal("BG")],
    ),
  ),
  billingFactor: S.optional(
    S.Union(
      [S.Literal("privatversicherte"),
      S.Literal("bahnbeamte_1-3"),
      S.Literal("bahnbeamte_unfall"),
      S.Literal("postbeamte_b"),
      S.Literal("postbeamte_unfall"),
      S.Literal("bundespolizei_ambulant"),
      S.Literal("bundespolizei_stationär"),
      S.Literal("bundeswehr_ambulant"),
      S.Literal("bundeswehr_stationär"),
      S.Literal("entschaedigungsamt_berlin"),
      S.Literal("pkv_standard"),
      S.Literal("pkv_student"),
      S.Literal("pkv_basis"),
      S.Literal("knappschaft")],
    ),
  ),
  ownCodesFixedBillingFactor: S.optional(S.Boolean),
  mobileEgkId: S.optional(S.String),
  cdmVersion: S.optional(S.String),
  cardTypeGeneration: S.optional(
    S.Union(
      [S.Literal("0"),
      S.Literal("G0"),
      S.Literal("G1"),
      S.Literal("G1plus"),
      S.Literal("G2")],
    ),
  ),
  cardType: S.optional(S.Union([S.Literal("KVK"), S.Literal("EGK")])),
  terminalType: S.optional(
    S.Union([S.Literal("unknown"), S.Literal("fixed"), S.Literal("mobile")]),
  ),
  fk4108: S.optional(S.String),
  cardSwipe: S.optional(S.String),
  cardValidTo: S.optional(S.String),
  fk4133: S.optional(S.String),
  fk4110: S.optional(S.String),
  policyHolder: S.optional(S.String),
  policyDob: S.optional(S.String),
  insuranceKind: S.optional(S.String),
  persGroup: S.optional(
    S.Union(
      [S.Literal(""),
      S.Literal("4"),
      S.Literal("6"),
      S.Literal("7"),
      S.Literal("8"),
      S.Literal("9")],
    ),
  ),
  dmp: S.optional(S.String),
  costCarrierBillingSection: S.optional(S.String),
  costCarrierBillingGroup: S.optional(S.String),
  paidFree: S.optional(S.Boolean),
  locationFeatures: S.optional(S.String),
  notes: S.optional(S.String),
  feeSchedule: S.optional(S.String),
  kv: S.optional(S.String),
  locationId: S.optional(S.String),
  employeeId: S.optional(S.String),
  fused: S.optional(S.Boolean),
  fusedFrom: S.optional(S.String),
  fusedToInsuranceId: S.optional(S.String),
  unzkv: S.optional(S.Array(S.String)),
  bgNumber: S.optional(S.String),
  address1: S.optional(S.String),
  address2: S.optional(S.String),
  zipcode: S.optional(S.String),
  city: S.optional(S.String),
  phone: S.optional(S.String),
  insuranceLink: S.optional(S.String),
  email: S.optional(S.String),
  insuranceGLN: S.optional(S.String),
  recipientGLN: S.optional(S.String),
  changebillingtypedesc: S.optional(S.Boolean),
  department: S.optional(S.String),
  originalInsuranceId: S.optional(S.String),
  originalInsuranceGrpId: S.optional(S.String),
  originalCostCarrierBillingSection: S.optional(S.String),
  fk3010: S.optional(S.String),
  fk3011: S.optional(S.String),
  fk3012: S.optional(S.String),
  fk3013: S.optional(S.String),
  createUniqCaseIdentNoOnInvoice: S.optional(S.Boolean),
  doNotShowInsuranceInGadget: S.optional(S.Boolean),
  unknownInsurance: S.optional(S.Boolean),
  isTiersGarant: S.optional(S.Boolean),
  isTiersPayant: S.optional(S.Boolean),
  vekaCardNo: S.optional(S.String),
  cardExpiryDate: S.optional(S.String),
  cardValidationDate: S.optional(S.String),
  unknownBillableInsurance: S.optional(S.Boolean),
  temporaryEntry: S.optional(S.Boolean),
});

const HzvContractSchema = S.Struct({
  activationType: S.optional(
    S.Union(
      [S.Literal("NEW_ENROLLMENT"),
      S.Literal("DIRECT_ACTIVATION"),
      S.Literal("REPRESENTATIVE_CASE")],
    ),
  ),
  contractId: S.optional(S.String),
  contractName: S.optional(S.String),
  contractNo: S.optional(S.String),
  employeeId: S.optional(S.String),
  insuranceEnrollmentType: S.optional(
    S.Union([S.Literal("ONLINE"), S.Literal("OFFLINE")]),
  ),
  participationIdentifier: S.optional(S.String),
  insuranceSignatureAvailability: S.optional(
    S.Union([S.Literal("YES"), S.Literal("NO")]),
  ),
  preventiveScheinIds: S.optional(S.Array(S.String)),
  reasonToChangeDoctor: S.optional(
    S.Union(
      [S.Literal("INSURED_RESIDENCY_CHANGED"),
      S.Literal("BROKEN_TRUST"),
      S.Literal("PRACTICE_CLOSURE"),
      S.Literal("DOCTOR_CHANGE_WITHIN_BAG_MVZ"),
      S.Literal("BINDING_PERIOD_ENDED"),
      S.Literal("PHYSICIAN_HZV_PARTICIPATION_ENDED")],
    ),
  ),
  teCode: S.optional(S.String),
  declarationOfParticipationStatus: S.optional(
    S.Union(
      [S.Literal("GENERATED"),
      S.Literal("PRINTED"),
      S.Literal("INCORRECT"),
      S.Literal("SUCCESSFUL")],
    ),
  ),
  applicationDate: S.optional(S.String),
  participationStatus: S.optional(
    S.Union(
      [S.Literal("HANDED_OUT"),
      S.Literal("RECEIVED"),
      S.Literal("REQUESTED"),
      S.Literal("ACTIVE"),
      S.Literal("ENDED"),
      S.Literal("REJECTED"),
      S.Literal("CANCELED")],
    ),
  ),
  participationStartDate: S.optional(S.String),
  participationEndDate: S.optional(S.String),
  receiptDate: S.optional(S.String),
  handOverDate: S.optional(S.String),
  insuranceId: S.optional(S.String),
  insuranceNo: S.optional(S.String),
  locationId: S.optional(S.String),
  insuranceKind: S.optional(S.String),
});

const PartnerIdSchema = S.Struct({
  partnerId: S.optional(
    S.Union(
      [S.Literal("INCARE"),
      S.Literal("AP"),
      S.Literal("CARDIO"),
      S.Literal("DOQUVIDE"),
      S.Literal("ASV"),
      S.Literal("ONLINETHERAPY"),
      S.Literal("EDMP"),
      S.Literal("BIOTRONIK IN-TIME SOP"),
      S.Literal("DQS"),
      S.Literal("DYNAMIC")],
    ),
  ),
  patientId: S.optional(S.String),
  patientNotes: S.optional(S.String),
  insuranceType: S.optional(S.String),
  careType: S.optional(S.String),
  selectedType: S.optional(S.String),
  extra: S.optional(S.String),
  isDisabled: S.optional(S.Boolean),
  asvTeamNumbers: S.optional(S.Array(S.String)),
  onlineTherapyContract: S.optional(S.Array(S.String)),
  licenseModifier: S.optional(S.Union([S.Literal("DQS"), S.Literal("DQS RS")])),
});

export const CreatePatientRequestSchema = S.Struct({
  addresses: S.optional(S.Array(AddressSchema)),
  mirrorPatientId: S.optional(S.String),
  additionalMirrorPatientIds: S.optional(S.Array(S.String)),
  title: S.optional(S.String),
  firstname: S.String,
  nameaffix: S.optional(S.String),
  middlename: S.optional(S.String),
  fk3120: S.optional(S.String),
  lastname: S.String,
  civilStatus: S.optional(
    S.Union(
      [S.Literal("SINGLE"),
      S.Literal("MARRIED"),
      S.Literal("DIVORCED"),
      S.Literal("UNKNOWN")],
    ),
  ),
  comment: S.optional(S.String),
  patientStatus: S.optional(S.Array(S.String)),
  activeState: S.optional(S.Boolean),
  communications: S.optional(S.Array(CommunicationSchema)),
  isEmployed: S.optional(S.Boolean),
  weeklyWorkingHours: S.optional(S.Number),
  isPhysicalJob: S.optional(S.Boolean),
  isStandingJob: S.optional(S.Boolean),
  isSpiritualJob: S.optional(S.Boolean),
  isSittingJob: S.optional(S.Boolean),
  otherJobDescription: S.optional(S.String),
  lastEmploymentStatusCheck: S.optional(S.String),
  kbvDob: S.optional(S.String),
  insuranceStatus: S.optional(S.Array(InsuranceStatusSchema)),
  dataTransmissionToPVSApproved: S.optional(S.Boolean),
  GDPRFormApprovedVersion: S.optional(S.String),
  medicalConfidentialityReleaseFormApprovedVersion: S.optional(S.String),
  patientDataProtectionComplianceApproved: S.optional(S.Boolean),
  primaryDoc: S.optional(S.String),
  physicians: S.optional(S.Array(S.String)),
  employees: S.optional(S.Array(S.String)),
  markers: S.optional(S.Array(S.String)),
  hzvContractsPatientDetails: S.optional(S.Array(HzvContractSchema)),
  partnerIds: S.optional(S.Array(PartnerIdSchema)),
  careDegree: S.optional(
    S.Union(
      [S.Literal("NO"),
      S.Literal("ONE"),
      S.Literal("TWO"),
      S.Literal("THREE"),
      S.Literal("FOUR"),
      S.Literal("FIVE")],
    ),
  ),
  dob: S.String,
  dateOfDeath: S.optional(S.String),
  dateOfInActive: S.optional(S.String),
  isDeceased: S.optional(S.Boolean),
  isInactive: S.optional(S.Boolean),
  reason: S.optional(S.String),
  dob_MM: S.optional(S.String),
  dob_DD: S.optional(S.String),
  patientSince: S.optional(S.String),
  talk: S.Union([S.Literal("MR"), S.Literal("MS"), S.Literal("NONE")]),
  gender: S.Union(
    [S.Literal(""),
    S.Literal("MALE"),
    S.Literal("FEMALE"),
    S.Literal("VARIOUS"),
    S.Literal("UNKNOWN"),
    S.Literal("UNDEFINED")],
  ),
  patientNo: S.optional(S.String),
  socialSecurityNo: S.optional(S.String),
  birthname: S.optional(S.String),
  patientNumber: S.optional(S.Number),
  activeCaseFolderId: S.optional(S.String),
  institution: S.optional(S.String),
  familyDoctor: S.optional(S.String),
  edmpTypes: S.optional(S.Array(S.String)),
  edmpNotifiedAboutStatementOfParticipationTypes: S.optional(S.Array(S.String)),
  edmpCaseNo: S.optional(S.String),
  ehksPatientNo: S.optional(S.String),
  ehksActivated: S.optional(S.Boolean),
  ehksDocType: S.optional(S.Union([S.Literal("EHKSND"), S.Literal("EHKSD")])),
  HGVPatientNo: S.optional(S.String),
  HGVActivated: S.optional(S.Boolean),
  edmpParticipationChronicHeartFailure: S.optional(S.Boolean),
  cardioHeartFailure: S.optional(S.Boolean),
  cardioCryptogenicStroke: S.optional(S.Boolean),
  cardioCHD: S.optional(S.Boolean),
  invoiceRecipient: S.optional(S.String),
  locationId: S.optional(S.String),
  confirmedViewFromOtherLocations: S.optional(S.Boolean),
  confirmedViewFromLocationIds: S.optional(S.Array(S.String)),
  additionalContacts: S.optional(S.Array(S.String)),
  patientsFamilyMembers: S.optional(S.Array(S.Unknown)),
  additionalFamilyMembers: S.optional(S.Array(S.Unknown)),
  treatmentNeeds: S.optional(S.Boolean),
});

export type CreatePatientRequest = S.Schema.Type<typeof CreatePatientRequestSchema>;
